module.exports = __webpack_public_path__ + "static/win-run-anyway-d15b2452dadb4bb557d42575028a988f.png";